import React from "react";
import styled from "styled-components";

const StyledInput = styled.input<{ $hasError?: boolean }>`
  width: 100%;
  height: 48px;
  padding: 0 12px;

  background: white;
  border: 1px solid ${(props) => props.theme.colors.text}40;
  border-radius: 8px;
  outline: 0;
  appearance: none;

  font-family: ${(props) => props.theme.fonts.body};
  font-size: ${(props) => props.theme.fontSizes.sm}px;

  transition: all ${(props) => props.theme.transitions.simple};

  ${(props) =>
    props.$hasError
      ? `
  border-color: ${(props) => props.theme.colors.danger};
  `
      : ""}

  &:focus {
    border-color: ${(props) => props.theme.colors.text};
    box-shadow: ${(props) => props.theme.shadows.regular};
  }

  &::placeholder {
    color: ${(props) => props.theme.colors.text}55;
  }

  &[disabled] {
    background: ${(props) => props.theme.colors.primary}10;
    color: ${(props) => props.theme.colors.text}AA;
  }
`;

export interface InputProps
  extends React.InputHTMLAttributes<HTMLInputElement> {
  value?: any;
  hasError?: boolean;
}

const Input: React.ForwardRefRenderFunction<HTMLInputElement, InputProps> = (
  { name, onChange, hasError, ...props },
  ref
) => (
  <StyledInput
    name={name}
    onChange={onChange}
    ref={ref}
    $hasError={hasError}
    {...props}
  />
);

export default React.forwardRef(Input);
